export const sortDescending = (arrOfObj: any[], key: string) =>
  arrOfObj.toSorted((a, b) => (b[key] > a[key] ? 1 : -1));

export const sortAscending = (arrOfObj: any[], key: string) =>
  arrOfObj.toSorted((a, b) => (a[key] > b[key] ? 1 : -1));
